import { render, staticRenderFns } from "./LaitelaAutobuyerPane.vue?vue&type=template&id=79a079e2&"
import script from "./LaitelaAutobuyerPane.vue?vue&type=script&lang=js&"
export * from "./LaitelaAutobuyerPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports